module.exports = __webpack_public_path__ + "static/img/logo_02.1c268d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company/sustainability/logo_02.png
// module id = SFnb
// module chunks = 0